import { logWrapper } from '../utils';

function scrollyDirectiveFactory(runtimeConstant) {
  function run() {
    return {
      restrict: 'A',
      link: function (scope, element, attrs) {
        const rawElement = element[0];

        // Attach scroll event handler
        element.on('scroll', function () {
          const isNearBottom =
            rawElement.scrollTop + rawElement.offsetHeight + 500 >= rawElement.scrollHeight;

          if (isNearBottom) {
            scope.$apply(attrs.scrolly);
          }
        });
      },
    };
  }

  // Wrap the setup function with logWrapper for debugging purposes
  return logWrapper(run, runtimeConstant.isDebugDirectives)();
}

export const scrollyDirective = ['runtimeConstant', scrollyDirectiveFactory];
